import React from 'react';
import { Button, Checkbox, Form } from 'antd';
import { Translate } from '@above-the-treeline/localization';
import ReCAPTCHA from 'react-google-recaptcha';
import { RegistrationTypes } from '../../RegistrationEnums';
import { FormComponentProps } from 'antd/lib/form/Form';
import classNames from 'classnames';
import TermsOfService from '../TermsOfService/TermsOfService';
import './registrationFormSubmitButton.less';

const { Item } = Form;

interface IRegistrationFormSubmitButtonProps extends FormComponentProps {
	type: string;
}

export default function RegistrationFormSubmitButton({
	form,
	type,
}: IRegistrationFormSubmitButtonProps): JSX.Element {
	const { getFieldDecorator, getFieldsValue, getFieldsError } = form;
	const isSignUpModal = type === RegistrationTypes.SignUp;
	const isForgotPasswordModal = type === RegistrationTypes.ForgotPassword;
	const isResetPasswordModal = type === RegistrationTypes.ResetPassword;
	const formErrors = getFieldsError();
	const isButtonDisabled =
		Object.entries(getFieldsValue()).some(
			([key, val]) => key !== 'do_keep_me_updated' && val === undefined,
		) || Object.values(formErrors).some(val => Array.isArray(val));

	const submitButtonClass = classNames({
		'log-in-submit-button': type === RegistrationTypes.LogIn,
		'sign-up-submit-button': isSignUpModal,
		'reset-password-submit-button': isResetPasswordModal,
		'forgot-password-submit-button': isForgotPasswordModal,
	});

	return (
		<div
			className="registration-form-submit-button"
			style={isSignUpModal ? { marginTop: 24 } : {}}>
			{!isForgotPasswordModal && !isResetPasswordModal && (
				<Item>
					{isSignUpModal
						? getFieldDecorator('recaptcha', {
								rules: [
									{
										required: true,
										message: (
											<Translate id="please_verify_that_you_are_not_a_robot" />
										),
									},
								],
						  })(
								<ReCAPTCHA
									sitekey={
										process.env.REACT_APP_RECAPTCHA_KEY
									}
								/>,
						  )
						: getFieldDecorator('rememberMe', {
								valuePropName: 'checked',
								initialValue: true,
						  })(
								<Checkbox>
									<Translate id="remember_me" />
								</Checkbox>,
						  )}
				</Item>
			)}
			{isSignUpModal && <TermsOfService />}
			<Item>
				<Button
					className={submitButtonClass}
					type="primary"
					shape="round"
					htmlType="submit"
					disabled={isButtonDisabled}>
					<Translate id={isForgotPasswordModal ? 'submit' : type} />
				</Button>
			</Item>
		</div>
	);
}
